<template>
  <b-overlay :show="showLoading">
    <div class="overflow-auto w-100">
      <!-- Page Header Start -->
      <div class="row page-title-header">
        <div class="col-12">
          <BreadCrumb
            :parentRouteName="isBookingCenter() ? '' : 'BookingSelectList'"
            :extra-items="isBookingCenter() ? [
              '登記預約中心',
              {
                text: bookingPreset.name ?? '',
                to: 'BookingCenterBookingList',
                params: $route.params.id
              },
              '估價單'
            ] : [
              {
                text: bookingPreset.name ?? '',
                to: 'BookingList',
                params: $route.params.id
              },
              '估價單'
            ]"
          />
        </div>

        <div class="col-12 d-flex justify-content-end">
          <b-button
            v-if="checkPermission([consts.BOOKING_QUOTATION_TO_INVOICE])"
            class="col-1 mr-1"
            variant="inverse-primary"
            v-on:click="createInvoice">
            <i class="fa fa-file-invoice-dollar"></i> 開立發票
          </b-button>
          <b-button class="col-1" variant="inverse-info" v-on:click="generatePdf">
            <span class="mdi mdi-printer"></span> 列印
          </b-button>
        </div>
      </div>
      <!-- Page Header End -->

      <div class="pdf-container mx-auto" id="download-pdf">
        <header class="my-4" v-html="getCleanedHtml(bookingPreset.config.quotation_header)">
          <!--          <div class="row header-div align-items-center">-->
          <!--            <div class="col-md-6 text-center">-->
          <!--              <img src="https://storage.googleapis.com/waltily-dev/upload_images/HIYEvgCYd2kZz5iC.jpeg" alt="公司 Logo" class="img-fluid">-->
          <!--            </div>-->
          <!--            <div class="col-md-6" style="text-align: justify;">-->
          <!--              <h1 class="h4">金谷旅行社有限公司</h1>-->
          <!--              <h2 class="h5">金谷通運股份有限公司</h2>-->
          <!--              <p>服務專線：03-5313788 FAX：03-5339149</p>-->
          <!--              <p>服務地址：新竹市經國路二段100號8樓812室</p>-->
          <!--            </div>-->
          <!--          </div>-->
        </header>

        <h3 class="quote-title" v-html="title">估價單</h3>
        <p class="customer-info color-blue" v-html="subTitle"></p>

        <table class="quote-table" v-if="isCompletedFormated">
          <!--        <thead>-->
          <!--        <tr>-->
          <!--          <th>日期</th>-->
          <!--          <th>序號</th>-->
          <!--          <th>內容</th>-->
          <!--          <th>數量</th>-->
          <!--          <th>單位</th>-->
          <!--          <th>單價</th>-->
          <!--          <th>合計</th>-->
          <!--          <th>備註</th>-->
          <!--        </tr>-->
          <!--        </thead>-->
          <!--        <tbody>-->
          <!--        <tr>-->
          <!--          <td class="color-blue">4月8日</td>-->
          <!--          <td class="color-blue">1</td>-->
          <!--          <td class="color-blue">08:40 新竹羅技電子 → 台威科技<br>13:30 台灣桃園 → 17:00 回程</td>-->
          <!--          <td class="color-blue">1</td>-->
          <!--          <td class="color-blue">中巴</td>-->
          <!--          <td class="color-blue">10,500</td>-->
          <!--          <td>10,500</td>-->
          <!--          <td></td>-->
          <!--        </tr>-->
          <!--        <tr>-->
          <!--          <td colspan="5">此報價含(路.停車費.司機小費.乘客險.誤餐費)</td>-->
          <!--          <td>總計</td>-->
          <!--          <td>10,500</td>-->
          <!--          <td>(<span class="color-blue">含</span>稅)</td>-->
          <!--        </tr>-->
          <!--        </tbody>-->
          <thead>
            <tr>
              <th v-for="(header, index) in bookingPreset.config
                .quotation_content_header" :key="'header-' + index" v-html="header.value && header.value.trim()
                  ? header.value
                  : header.text || ''
                  " :style="header.style" :colspan="header.colspan || 1"></th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(bookingFormatData, bookingIndex) in bookings" :key="'booking-' + bookingIndex">
              <td v-for="(content, index) in getProcessedContent(bookingFormatData, bookingPreset.config.quotation_content, bookingIndex)"
                  :key="'content-' + bookingIndex + '-' + index"
                  :style="content.style ? parseStyle(content.style) : tdStyles[index]"
                  :colspan="content.colspan || 1"
                  v-html="content.value && content.value.trim()
                      ? content.value
                      : content.text || ''
                      ">
              </td>
            </tr>
            <tr>
              <td v-for="(footer, index) in getProcessedContent(bookings[0], bookingPreset.config.quotation_content_footer)"
                  :key="'footer-' + index" :colspan="footer.colspan || 1"
                  :style="footer.style" v-html="footer.value && footer.value.trim()
                    ? footer.value
                    : footer.text || ''
                    "></td>
            </tr>
          </tbody>
        </table>

        <footer v-html="getCleanedHtml(bookingPreset.config.quotation_footer)">
          <!--        <div class="row align-items-center" style="width: 100%;margin-bottom: 20px;">-->
          <!--          <div class="col-md-6">-->
          <!--            <p>金谷運通股份有限公司</p>-->
          <!--            <p>統一編號：47126655</p>-->
          <!--            <p>經辦人：盧郁潔</p>-->
          <!--            <p>電話：03-5313788</p>-->
          <!--            <p>傳真：03-5339149</p>-->
          <!--            <p>地址：300新竹市經國路二段100號8樓812室</p>-->
          <!--          </div>-->
          <!--          <div class="stamp col-md-6" style="text-align: center">-->
          <!--            <img src="stamp-placeholder.png" alt="公司印章">-->
          <!--          </div>-->
          <!--        </div>-->

          <!--        <div>-->
          <!--          <p>款項如匯款或支票付款，請參考下列資料：</p>-->
          <!--          <p>戶名：金谷通運股份有限公司</p>-->
          <!--          <p>帳號：313-10-059599</p>-->
          <!--          <p>銀行：第一銀行竹北分行</p>-->
          <!--          <p>銀行代號：007</p>-->
          <!--          <p>支票抬頭：金谷通運股份有限公司</p>-->
          <!--        </div>-->
        </footer>
      </div>
    </div>
  </b-overlay>
</template>

<script>
import {zh} from "vuejs-datepicker/dist/locale";
import useVuelidate from "@vuelidate/core";
import bookingApi from "@/apis/booking";
import invoiceApi from "@/apis/invoice";
import * as consts from "@/consts";
import PermissionChecker from "@/utils/PermissionChecker";
import _ from "lodash";
import {mapGetters} from "vuex";
import html2pdf from "html2pdf.js/src";
import BreadCrumb from "@/components/Dashboard/BreadCrumb";

export default {
  components: { BreadCrumb },
  setup: () => ({ v$: useVuelidate({ $scope: false }) }),
  data() {
    return {
      consts,
      zh,
      isEditing: false,
      showLoading: false,
      validationErrors: null,
      showAddStaff: false,
      step: "",
      isCompletedFormated: false,
      bookingPreset: {
        name: null,
        config: {
          fields: [],
          quotation_header: null,
          quotation_title: null,
          quotation_subTitle: null,
          quotation_content_header: [
            // { text: "日期", style: "" },
            // { text: "序號", style: "" },
            // { text: "內容", style: "" },
            // { text: "數量", style: "" },
            // { text: "單位", style: "" },
            // { text: "單價", style: "" },
            // { text: "合計", style: "" },
            // { text: "備註", style: "" },
          ],
          quotation_content: [
            // { text: "4月8日", style: "color: cornflowerblue;" },
            // { text: "1", style: "color: cornflowerblue" },
            // {
            //   text: "08:40 新竹羅技電子 → 台威科技<br>13:30 台灣桃園 → 17:00 回程",
            //   style: "color: cornflowerblue",
            // },
            // { text: "1", style: "color: cornflowerblue" },
            // { text: "中巴", style: "color: cornflowerblue" },
            // { text: "10,500", style: "color: cornflowerblue" },
            // { text: "10,500", style: "" },
            // { text: "", style: "" },
          ],
          quotation_content_footer: [
            // {
            //   text: "此報價含(路.停車費.司機小費.乘客險.誤餐費)",
            //   style: "",
            //   colspan: 5,
            // },
            // { text: "總計", style: "" },
            // { text: "10,500", style: "" },
            // { text: "(含稅)", style: "" },
          ],
          quotation_footer: null,
        },
      },
      config: {},
      start_at: null,
      end_at: null,
      bookings: [],
      booking: {
        customer_id: null,
        service_id: [],
        staff_id: null,
        branch_id: null,
        start_at: null,
        end_at: null,
        data: [],
      },
      bookingIds: [],
      bookingFormatData: {},
      customer: null,
      disabledBranchSelect: false,
      tdStyles: [
        { whiteSpace: "nowrap" }, // 日期
        { whiteSpace: "nowrap" }, // 序號
        { wordBreak: "break-word" }, // 內容
        { whiteSpace: "nowrap" }, // 數量
        { whiteSpace: "nowrap" }, // 單位
        { whiteSpace: "nowrap" }, // 單價
        { whiteSpace: "nowrap" }, // 合計
        { whiteSpace: "nowrap" }, // 備註
      ],
      customStyles: [
        {  }, // 日期
        {  }, // 序號
        {  }, // 內容
        {  }, // 數量
        {  }, // 單位
        { isMoney: true }, // 單價
        { isMoney: true }, // 合計
        {  }, // 備註
      ]
    };
  },
  mounted() {
    this.init();
  },
  computed: {
    ...mapGetters("route", ["routeQuery", "routeParams"]),
    ...mapGetters("general", ["myBranches"]),
    title() {
      const raw = _.get(this.bookingPreset, 'config.quotation_title', null)
      const replaced = this.replaceBookingDataVariables(raw)
      const output = (typeof replaced === 'string') ? replaced.trim() : ''
      return output ? output : '估價單'
    },
    subTitle() {
      const raw = _.get(this.bookingPreset, 'config.quotation_subTitle', null)
      const replaced = this.replaceBookingDataVariables(raw)
      return (typeof replaced === 'string') ? replaced.trim() : ''
    }
  },
  methods: {
    escapeHtml(html) {
      return `<pre><code>${html}</code></pre>`;
    },
    deepGet: _.get,
    async createInvoice() {
      const result = await this.$swal({
        type: "question",
        title: "確認開立發票",
        text: "是否確認開立發票？",
        confirmButtonText: "確認開立",
        cancelButtonText: "取消",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
      });

      if (!result.value) {
        return;
      }

      try {
        this.showLoading = true;

        // 提取並轉換金額（從字串中提取連續的數字，返回整數）
        const extractPrice = (priceStr) => {
          if (!priceStr) return 0;
          const str = priceStr.toString();
          // 匹配數字（包含逗號），例如：1,234 或 1234
          const match = str.match(/[\d,]+/);
          if (match) {
            // 移除逗號後轉換為整數
            return parseInt(match[0].replace(/,/g, ''), 10);
          }
          return 0;
        };

        // 從 quotation_content 配置中找出對應的欄位索引
        const contentConfig = this.bookingPreset.config.quotation_content;

        // 定義一個輔助函數來從配置中提取指定索引的值
        const getValueFromConfig = (bookingFormatData, configIndex) => {
          const processedContent = this.getProcessedContent(bookingFormatData, contentConfig);
          if (processedContent && processedContent[configIndex]) {
            return processedContent[configIndex].text || processedContent[configIndex].value || '';
          }
          return '';
        };

        // 移除 HTML 標籤的輔助函數
        const stripHtml = (html) => {
          if (!html) return '';
          return html.toString()
            .replace(/<br\s*\/?>/gi, '\n')  // 先將 <br> 轉為換行
            .replace(/<[^>]+>/g, '')         // 移除所有 HTML 標籤
            .replace(/&nbsp;/g, ' ')         // 移除 &nbsp;
            .trim();
        };

        // 從 preset 讀取發票品名、備註、日期設定
        const presetInvoiceItemName = this.bookingPreset.config?.invoice_item_name || null;
        const presetInvoiceRemark   = this.bookingPreset.config?.invoice_remark || null;
        const presetInvoiceIssueDate = this.bookingPreset.config?.invoice_issue_date || null;

        // 建立 invoiceItems（遍歷所有 bookings）
        const invoiceItems = this.bookings.map((bookingFormatData, index) => {
          // 根據表格結構提取資料
          // 假設表格欄位順序為：日期(0)、序號(1)、內容(2)、數量(3)、單位(4)、單價(5)、合計(6)、備註(7)
          const content = stripHtml(getValueFromConfig(bookingFormatData, 2));  // 內容欄位
          const unit = stripHtml(getValueFromConfig(bookingFormatData, 4));     // 單位欄位
          const unitPriceStr = getValueFromConfig(bookingFormatData, 5);  // 單價
          const amountStr = getValueFromConfig(bookingFormatData, 6);     // 合計
          const quantityStr = getValueFromConfig(bookingFormatData, 3);   // 數量

          // 從內容欄位解析出發地和目的地
          // 內容格式可能是：「出發地：xxx\n目的地：yyy」
          const contentLines = content.split('\n');
          const departure = contentLines[0] ? contentLines[0].replace('出發地：', '').trim() : '';
          const destination = contentLines[1] ? contentLines[1].replace('目的地：', '').trim() : '';

          // 發票品名：preset 有設定則用 preset 值，否則組出發地+目的地
          const itemName = presetInvoiceItemName || `出發地: ${departure} 目的地: ${destination} ${unit}`;

          // 發票備註：preset 有設定則套用插值
          const itemMemo = presetInvoiceRemark
            ? this.replaceBookingDataVariables(presetInvoiceRemark, bookingFormatData.booking)
            : null;

          return {
            name: itemName,
            unit_price: extractPrice(unitPriceStr),
            quantity: parseInt(quantityStr) || 1,
            amount: extractPrice(amountStr),
            row_num: (index + 1).toString(),
            ...(itemMemo !== null ? { processed_memo: itemMemo } : {}),
          };
        });

        // 計算總金額（加總所有 invoiceItems 的 amount）
        const totalPrice = invoiceItems.reduce((sum, item) => sum + item.amount, 0);

        // 建立 invoiceMappings（每個 booking 各自獨立一個 mapping）
        const invoiceMappings = this.bookings.map((bookingFormatData) => {
          return {
            source_type: 'booking',
            source_id: bookingFormatData.booking.id.toString()
          };
        });

        // 從 booking.data 提取買方資訊的輔助函數
        const extractBuyerInfo = () => {
          const buyerInfo = {};

          // 取得欄位 ID 配置
          const buyerBizNumId = this.bookingPreset.config?.buyer_business_number_id;
          const buyerCompNameId = this.bookingPreset.config?.buyer_company_name_id;

          // 從 booking.data 提取統編
          if (buyerBizNumId) {
            const bizNumField = this.booking.data?.find(d => d.field_id === buyerBizNumId);
            if (bizNumField?.value) {
              buyerInfo.buyer_ban = bizNumField.value;
            }
          }

          // 從 booking.data 提取公司名稱
          if (buyerCompNameId) {
            const compNameField = this.booking.data?.find(d => d.field_id === buyerCompNameId);
            if (compNameField?.value) {
              buyerInfo.buyer_company_name = compNameField.value;
            }
          }

          return buyerInfo;
        };

        const buyerInfo = extractBuyerInfo();

        // 發票開立日期：preset 有設定則套用插值，否則用當天日期
        const invoiceDate = presetInvoiceIssueDate
          ? this.replaceBookingDataVariables(presetInvoiceIssueDate)
          : new Date().toISOString().split('T')[0];

        // 準備完整的發票資料
        const invoiceData = {
          merchant_id: this.bookings[0].customer.merchant.id,
          customer_name: this.bookings[0].customer.name,
          total_price: totalPrice,
          invoice_type: 'electronic',
          invoice_date: invoiceDate,
          invoice_source: 'internal',
          invoiceItems: invoiceItems,
          invoiceMappings: invoiceMappings,
          ...buyerInfo
        };

        console.log('準備建立發票，資料如下：', invoiceData);

        await invoiceApi.createAndIssueInvoice(invoiceData);
        this.$swal("成功", "發票已建立並開立", "success");

      } catch (error) {
        console.error(error);

        // 檢查是否為 KTNet 相關錯誤
        const errorData = error.response?.data;
        if (errorData?.type === 'App\\Services\\KTNet\\Exceptions\\KTNetException') {
          // 顯示 KTNet 的詳細錯誤訊息
          const errorMessage = errorData.message || '未知錯誤';
          const errorCode = errorData.code || '未知';
          this.$swal({
            icon: "error",
            title: "發票開立失敗",
            html: `<div style="text-align: left;">
              <p><strong>錯誤代碼：</strong>${errorCode}</p>
              <p><strong>錯誤訊息：</strong>${errorMessage}</p>
            </div>`,
          });
        } else if (errorData?.message) {
          // 其他有 message 的錯誤
          this.$swal("錯誤", errorData.message, "error");
        } else {
          // 一般錯誤
          this.$swal("錯誤", "建立發票失敗", "error");
        }
      } finally {
        this.showLoading = false;
      }
    },
    async generatePdf() {
      const element = document.getElementById("download-pdf"); // 選擇要匯出的區塊
      const serialNumber = this.bookingPreset.config.quotation_content[1].text
      const options = {
        filename: `${serialNumber || 'exported'}.pdf`, // PDF 檔名
        html2canvas: { scale: 2, useCORS: true }, // 提高解析度
        jsPDF: { unit: "in", format: "a4", orientation: "portrait" }, // PDF 格式
      };

      html2pdf().set(options).from(element).save();
    },
    checkPermission(permissions) {
      const checker = new PermissionChecker();
      return checker.check(permissions);
    },
    isBookingCenter() {
      return this.$route.name.includes("BookingCenter");
    },
    async init() {
      this.showLoading = true;
      this.bookingPreset.id = this.$route.params.id;

      // collect booking ids from query or fallback to param (legacy)
      const q = this.$route.query.booking_ids;
      if (Array.isArray(q)) {
        this.bookingIds = q;
      } else if (typeof q === 'string' && q.length) {
        this.bookingIds = q.split(',');
      } else if (this.$route.params.booking_id) {
        this.bookingIds = [this.$route.params.booking_id];
      }

      await this.fetchBookingPreset();
      this.isEditing = true;

      if (
        !this.checkPermission([
          this.consts.BOOKING_MANAGE_BRANCH,
          this.BOOKING_LIST_QUOTATION,
        ])
      ) {
        this.disabledBranchSelect = true;
      }
    },
    async fetchBookingPreset() {
      if (!this.bookingPreset.id) {
        this.$swal("錯誤", "無法取得讀取 ID", "error");
        return;
      }

      try {
        let response = await bookingApi.getBookingPreset(this.bookingPreset.id);

        if (!response.data.data.config) {
          response.data.data.config = {
            fields: [],
          };
        }

        this.bookingPreset = response.data.data;

        this.bookingPreset.config.fields = this.bookingPreset.config.fields.map(
          (field) => {
            return {
              id: field._id ?? field.config._id, // 這裡是為了因應新版 DynamicFormEditor 變動而捕的防禦
              ...field,
              ...field.config,
            };
          }
        );

        this.booking.id = Array.isArray(this.bookingIds) && this.bookingIds.length ? this.bookingIds[0] : this.$route.params.booking_id;

        // await this.fetchBooking();
        await this.fetchBookings();
      } catch (error) {
        console.error(error);
        this.$swal("錯誤", "讀取資料錯誤", "error");
        this.cancel();
      } finally {
        this.showLoading = false;
      }
    },
    replaceTemplateVariables(text, bookingFormatData) {
      if (!text) return text;
      return text.replace(/\{\{(.*?)\}\}/g, (match, content) => {
        // 移除開頭的 $ 符號（如果有的話）
        const path = content.trim().replace(/^\$/, '');
        const value = this.deepGet(bookingFormatData, path);
        return value !== undefined ? value : '';
      });
    },
    replaceBookingDataVariables(text, booking = null) {
      if (!text) return text;
      const bookingToUse = booking || this.booking;
      const bookingDataMap = _.chain(bookingToUse)
        .get('data', [])
        .keyBy('field_id')
        .mapValues('value')
        .value();

      const bookingMapping = this.bookingPreset?.config?.booking_mapping?.bookings || {};
      const startAtUuid = bookingMapping.start_at;
      const endAtUuid = bookingMapping.end_at;

      const parseDate = (uuid) => {
        const raw = bookingDataMap[uuid];
        if (!raw) return '';
        return String(raw).match(/^(\d{4}-\d{2}-\d{2})/)?.[1] || '';
      };

      const parseDateTime = (uuid) => {
        const raw = bookingDataMap[uuid];
        if (!raw) return '';
        const m = String(raw).match(/^(\d{4}-\d{2}-\d{2})\s+(\d{2}:\d{2})/);
        return m ? `${m[1]} ${m[2]}` : '';
      };
      const parseTime = (uuid) => {
        const raw = bookingDataMap[uuid];
        if (!raw) return '';
        return String(raw).match(/\b(\d{2}:\d{2})\b/)?.[1] || '';
      };
      const parseDateTimeAddOneMinute = (uuid) => {
        const raw = bookingDataMap[uuid];
        if (!raw) return '';
        const m = String(raw).match(/^(\d{4}-\d{2}-\d{2})\s+(\d{2}):(\d{2})/);
        if (!m) return '';
        const [ , date, hour, minute ] = m;
        const parsed = new Date(`${date}T${hour}:${minute}:00`);
        if (Number.isNaN(parsed.getTime())) return '';
        parsed.setMinutes(parsed.getMinutes() + 1);
        const yyyy = parsed.getFullYear();
        const mm = String(parsed.getMonth() + 1).padStart(2, '0');
        const dd = String(parsed.getDate()).padStart(2, '0');
        const hh = String(parsed.getHours()).padStart(2, '0');
        const min = String(parsed.getMinutes()).padStart(2, '0');
        return `${yyyy}-${mm}-${dd} ${hh}:${min}`;
      };
      const parseDateAddOneMinute = (uuid) => {
        const dateTime = parseDateTimeAddOneMinute(uuid);
        if (!dateTime) return '';
        return dateTime.slice(0, 10);
      };
      const parseTimeAddOneMinute = (uuid) => {
        const dateTime = parseDateTimeAddOneMinute(uuid);
        if (!dateTime) return '';
        return dateTime.slice(11, 16);
      };

      const namedVars = {
        StartDate:          () => parseDate(startAtUuid),
        StartDateTime:      () => parseDateTime(startAtUuid),
        EndDate:            () => parseDate(endAtUuid),
        EndDateTime:        () => parseDateTime(endAtUuid),
        StartToEndDate:     () => {
          const s = parseDate(startAtUuid);
          const e = parseDate(endAtUuid);
          if (!s) return '';
          return s === e ? s : `${s} ~ ${e}`;
        },
        StartToEndDateTime: () => {
          const s = parseDateTime(startAtUuid);
          const e = parseDateTime(endAtUuid);
          const sd = parseDate(startAtUuid);
          const ed = parseDate(endAtUuid);
          const et = parseTime(endAtUuid);
          if (!s) return '';
          if (sd === ed) {
            return et ? `${s}~${et}` : s;
          }
          return `${s} ~ ${e}`;
        },
        StartToEndDateTimeAdd1Min: () => {
          const s = parseDateTime(startAtUuid);
          const e = parseDateTimeAddOneMinute(endAtUuid);
          const sd = parseDate(startAtUuid);
          const ed = parseDateAddOneMinute(endAtUuid);
          const et = parseTimeAddOneMinute(endAtUuid);
          if (!s) return '';
          if (sd === ed) {
            return et ? `${s}~${et}` : s;
          }
          return `${s} ~ ${e}`;
        },
      };

      const pattern = /\{\{\s*\$?booking_data\[(?:'|")([^'"]+)(?:'|")\]\s*\}\}/g;
      return String(text).replace(pattern, (match, fieldId) => {
        if (Object.prototype.hasOwnProperty.call(bookingDataMap, fieldId)) {
          const value = bookingDataMap[fieldId];
          if (value === undefined || value === null) return '';
          if (Array.isArray(value)) {
            return value.map(v => (typeof v === 'object' && v !== null) ? (v.text || '') : String(v)).join(', ');
          }
          return String(value);
        }
        if (Object.prototype.hasOwnProperty.call(namedVars, fieldId)) {
          return namedVars[fieldId]();
        }
        return '';
      });
    },
    async fetchBookings() {
      try {
        const response = await bookingApi.getBookingsWithFormatData(this.bookingPreset.id,
          { 'booking_ids' :this.bookingIds}
        );

        this.bookings = response.data.data;
        this.booking = this.bookings[0].booking;

        this.showLoading = false;
        this.isCompletedFormated = true;
      } catch (error) {
        this.showLoading = false;

        console.error(error);
        this.$swal("錯誤", "讀取錯誤", "error");
      } finally {
        this.showLoading = false;
      }
    },
    getCleanedHtml(text) {
      // 利用 textarea 解碼 HTML 實體字符
      const textarea = document.createElement('textarea');
      textarea.innerHTML = text;
      let decodedHtml = textarea.value;

      // 移除多餘的 &nbsp; 和 <br>（如果不需要）
      decodedHtml = decodedHtml.replace(/&nbsp;/g, ' '); // 替換掉 &nbsp;
      decodedHtml = decodedHtml.replace(/<br\s*\/?>(?!\s*<)/g, ''); // 移除 <br> 標籤

      // 移除多餘的空白字元（例如空格、換行符）
      decodedHtml = decodedHtml.replace(/\s+/g, ' ').trim(); // 替換所有空白字元並去除首尾的空白

      return decodedHtml;
    },
    parseStyle(styleStr) {
      if (typeof styleStr !== 'string') return {};
      return styleStr.split(';').reduce((acc, rule) => {
        const [key, value] = rule.split(':').map(s => s && s.trim());
        if (key && value) {
          acc[key] = value;
        }
        return acc;
      }, {});
    },
    getProcessedContent(bookingFormatData, originalContent, bookingIndex = null) {
      if (!Array.isArray(originalContent)) return [];

      return originalContent.map((item, index) => {
        const processedItem = { ...item };

        // 若為內容列且為第二欄（序號），以 bookingIndex+1 顯示
        if (originalContent === this.bookingPreset.config.quotation_content && index === 1 && typeof bookingIndex === 'number') {
          const seq = String(bookingIndex + 1);
          processedItem.text = seq;
          processedItem.value = seq;
          return processedItem;
        }

        if (processedItem.text && processedItem.text !== 'null') {
          // 如果是 footer 內容且有多個 bookings，則進行加總計算
          if (this.bookings && this.bookings.length > 1 && originalContent === this.bookingPreset.config.quotation_content_footer) {
            const replacedText = this.replaceTemplateVariablesWithSum(processedItem.text);
            processedItem.text = (replacedText !== 'null') ? this.formatMoney(replacedText) : '';
          } else {
            const textAfterNamedVars = this.replaceBookingDataVariables(processedItem.text, bookingFormatData?.booking || null);
            const replacedText = this.replaceTemplateVariables(textAfterNamedVars, bookingFormatData);
            if (originalContent === this.bookingPreset.config.quotation_content_footer) {
              processedItem.text = (replacedText !== 'null') ? this.formatMoney(replacedText) : '';
            } else {
              processedItem.text = (replacedText !== 'null') ? replacedText : '';
            }
          }

          // 根據 customStyles 應用格式化
          if (this.customStyles[index] && this.customStyles[index].isMoney) {
            processedItem.text = this.formatMoney(processedItem.text);
          }
        } else {
          processedItem.text = '';
        }


        return processedItem;
      });
    },
    formatMoney(value) {
      if (!value || value === 'null' || value === '') return value;

      // 移除現有的 $ 符號和逗點
      let cleanValue = String(value).replace(/[$,]/g, '');

      // 檢查是否為有效數字
      const numValue = parseFloat(cleanValue);
      if (isNaN(numValue)) return value;

      // 格式化為千分位並加上 $ 符號
      return '$' + numValue.toLocaleString('en-US');
    },
    replaceTemplateVariablesWithSum(text) {
      if (!text) return text;

      return text.replace(/\{\{(.*?)\}\}/g, (match, content) => {
        const path = content.trim().replace(/^\$/, '');

        // footer 中的所有變數都進行加總計算
        return this.calculateSumFromAllBookings(path);
      });
    },

    calculateSumFromAllBookings(path) {
      let total = 0;

      this.bookings.forEach(booking => {
        const value = this.deepGet(booking || {}, path);

        if (value !== undefined && value !== null) {
          // 嘗試轉換為數字並加總
          const numValue = parseFloat(value);
          if (!isNaN(numValue)) {
            total += numValue;
          }
        }
      });

      return this.formatMoney(total).toString();
    },
  },
};
</script>

<style lang="scss" scoped>
.header-div {
  width: 100%;
}

.pdf-container {
  width: 793.701px;
  padding: 20px;
  border: 1px solid #ccc;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
}

header {
  display: flex;
  align-items: center;
  padding-bottom: 10px;
  margin-bottom: 20px;
}

.logo img {
  width: 100px;
  height: auto;
}

.company-info {
  margin-left: 20px;
}

.company-info h1,
.company-info h2 {
  margin: 0;
  font-size: 20px;
}

.quote-title {
  text-align: center;
  font-size: 24px;
  margin: 10px 0;
}

.color-blue {
  color: cornflowerblue;
}

.customer-info {
  text-align: center;
  font-size: 18px;
  margin-bottom: 20px;
}

.quote-table {
  width: 100%;
  border-collapse: collapse;
}

.quote-table th,
.quote-table td {
  border: 1px solid #ccc;
  padding: 10px;
  text-align: center;
}

.quote-table th {
  background-color: #f4f4f4;
  word-break: keep-all;
}

.quote-table td {
  border: 1px solid #ccc;
  padding: 10px;
  text-align: center;
}

.total {
  text-align: right;
  font-size: 18px;
  font-weight: bold;
  margin-bottom: 20px;
}

footer {
  padding-top: 30px;
  text-align: left;
  margin-left: 30px;
}

.stamp img {
  width: 100px;
  height: auto;
  margin-top: 10px;
}

.img-fluid {
  width: 100px;
  height: 50px;
}

.menu-items > li {
  cursor: pointer;

  &.disabled {
    background-color: #ddd;
    opacity: 0.5;
    pointer-events: none;
  }

  .icon-for-done {
    display: none;
  }

  &.done {
    i {
      color: green;
    }

    .icon-for-done {
      display: unset;
    }

    .icon-for-undone {
      display: none;
    }
  }
}
</style>
